export default __webpack_public_path__ + "static/header-d2fcfd49c9a9814712ae2feb0cb8b07b.webp";